module.exports = __webpack_public_path__ + "static/media/petlee.68dde768.png";